var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopularTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4152_28939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6723 7.36966C28.1659 7.36966 26.9505 6.91763 26.5454 6.76695C24.4185 5.81266 20.9243 3 19 3C17.0757 3 13.5815 5.76243 11.4546 6.76695C11.1001 6.91763 9.8341 7.36966 9.32769 7.36966C8.51745 7.41989 7.90976 8.12305 8.01104 8.87644C8.2136 10.7348 8.72001 14.0497 10.0367 18.3189C11.7584 23.5927 16.5186 26.7569 18.3417 27.8117C18.7974 28.0628 19.3038 28.0628 19.7596 27.8117C21.5827 26.7569 26.3429 23.5927 27.9633 18.3189C29.28 14.0497 29.7864 10.7348 29.989 8.87644C30.0902 8.12305 29.4826 7.41989 28.6723 7.36966Z",
    fill: "url(#paint0_linear_4152_28939)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.014 9.22801C27.8114 10.7348 27.4063 13.2963 26.4948 16.5108C26.3935 16.9126 26.2416 17.3646 26.0897 17.7664C24.7224 22.1361 20.8737 24.8985 19 26.0035C18.7974 25.903 18.5949 25.7524 18.3923 25.6017C16.4174 24.2958 13.1764 21.6841 11.961 17.7664C10.7963 13.9995 10.2899 10.9357 10.0367 9.22801C10.9482 9.02711 12.0623 8.6253 12.2648 8.52485C13.1257 8.12304 14.0879 7.57055 15.1007 6.91762C16.2148 6.21445 18.291 4.9588 19 4.9588C19.709 4.9588 21.7852 6.26468 22.8993 6.91762C23.9121 7.52033 24.8743 8.12304 25.7352 8.52485C25.9884 8.57507 27.1025 9.02711 28.014 9.22801Z",
    fill: "url(#paint1_linear_4152_28939)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4949 16.4606C26.3936 16.8624 26.2417 17.3144 26.0898 17.7162C24.7225 22.0859 20.8738 24.8483 19.0001 25.9533C18.7976 25.8529 18.595 25.7022 18.3925 25.5515L14.6451 15.1045L16.4175 14.8031L18.6457 16.4104L23.4565 12.995L24.9757 12.4927C24.9757 12.543 25.634 14.3009 26.4949 16.4606Z",
    fill: "url(#paint2_linear_4152_28939)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8858 18.57L14.8474 15.5565C14.6448 15.3556 14.6448 14.9538 14.8474 14.7529L16.0627 13.5474C16.2653 13.3465 16.6704 13.3465 16.873 13.5474L18.2909 14.9538C18.4935 15.1547 18.7973 15.1547 18.9492 14.9538L22.7473 11.1868C22.9498 10.9859 23.355 10.9859 23.5575 11.1868L24.7729 12.3922C24.9754 12.5931 24.9754 12.9949 24.7729 13.1959L19.405 18.57C18.9492 18.9718 18.2909 18.9718 17.8858 18.57Z",
    fill: "url(#paint3_linear_4152_28939)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4152_28939",
    x: 0,
    y: 0,
    width: 38,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4152_28939"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4152_28939",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4152_28939",
    x1: 17.797,
    y1: 10.7448,
    x2: 24.8524,
    y2: 20.7251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4152_28939",
    x1: 25.5579,
    y1: 21.1467,
    x2: 14.921,
    y2: 7.48942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4152_28939",
    x1: 18.9471,
    y1: 14.6574,
    x2: 22.1183,
    y2: 19.8087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#657EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4152_28939",
    x1: 21.7271,
    y1: 15.9428,
    x2: 18.717,
    y2: 12.6477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularTraining);
export default __webpack_public_path__ + "static/media/popularTraining.99051fb1.svg";
export { ForwardRef as ReactComponent };